import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";
import PropTypes from "prop-types";
import React from "react";

const RaikoSimpleMultiLineInputOutlined = (
    {
        labelText = "",
        placeHolder = "",
        value,
        setValue,
        onChange,
        className,
        row = 5,
        disabled
    }) => {
    return (
        <RaikoMaterialOutlinedInput
            placeHolder={placeHolder}
            labelText={labelText}
            className={className}
            disabled={disabled}
            multiline={true}
            value={value}
            rows={row}
            onChange={e => {
                if (onChange)
                    onChange(e)

                if (setValue)
                    setValue(e.target.value)
            }}/>
    )
}

RaikoSimpleMultiLineInputOutlined.propTypes = {
    placeHolder: PropTypes.string,
    disabled: PropTypes.bool,
    row: PropTypes.number,
    labelText: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired
}


export default RaikoSimpleMultiLineInputOutlined